import { render, staticRenderFns } from "./list-acceptance.vue?vue&type=template&id=ef351d84&scoped=true&lang=pug&"
import script from "./list-acceptance.vue?vue&type=script&lang=js&"
export * from "./list-acceptance.vue?vue&type=script&lang=js&"
import style0 from "./list-acceptance.vue?vue&type=style&index=0&id=ef351d84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef351d84",
  null
  
)

export default component.exports